var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","column":""}},[_c('img',{staticClass:"Hero",attrs:{"src":require("../../assets/HubungiKami/Hero-mobile.svg")}}),_c('p',{staticClass:"Text-Hero"},[_vm._v(" Get In Touch ")])])}
var staticRenderFns = []

export { render, staticRenderFns }